export default [
    // {
    //     name: 'environmentMapTexture',
    //     type: 'cubeTexture',
    //     path: [
    //         new URL('../static/textures/environmentMap/px.jpg', import.meta.url),
    //         new URL('../static/textures/environmentMap/nx.jpg', import.meta.url),
    //         new URL('../static/textures/environmentMap/py.jpg', import.meta.url),
    //         new URL('../static/textures/environmentMap/ny.jpg', import.meta.url),
    //         new URL('../static/textures/environmentMap/pz.jpg', import.meta.url),
    //         new URL('../static/textures/environmentMap/nz.jpg', import.meta.url)
    //     ]

    // },
    {
        name: 'bakeTextureRed',
        type: 'texture',
        path: new URL('../static/assets/sneaker_texture.jpg', import.meta.url)

    },
    {
        name: 'bakeTextureBlue',
        type: 'texture',
        path: new URL('../static/assets/sneaker_texture_blue.jpg', import.meta.url)
    },
    {
        name: 'bakeTextureYellow',
        type: 'texture',
        path: new URL('../static/assets/sneaker_texture_yellow.jpg', import.meta.url)
    },
    {
        name: 'bakeTextureGreen',
        type: 'texture',
        path: new URL('../static/assets/sneaker_texture_green.jpg', import.meta.url)
    },
    {
        name: 'bakeTexturePurple',
        type: 'texture',
        path: new URL('../static/assets/sneaker_texture_purple.jpg', import.meta.url)
    },
    {
        name: 'sneakerModel',
        type: 'gltfModel',
        path: new URL('../static/assets/sneakers.glb', import.meta.url)
    }
]